import {Business, CurrentUser} from "../../../types/Types";
import {Form} from "react-bootstrap";
import * as React from "react";
import {useState} from "react";
import {useNavigate, useParams} from "react-router";
import TextField from "../../../components/form/TextField";
import LocationSelector from "../../../components/form/LocationSelector";
import NumberField from "../../../components/form/NumberField";
import {httpsCallable} from "@firebase/functions";
import {functions} from "../../../firebase/FirebaseProvider";

interface Props {
  currentUser: CurrentUser,
  business: Business | undefined,
}

function MenuItemCreationPage(props: Props) {
  const navigate = useNavigate();
  const [creating, setCreating] = useState<boolean>(false);

  const [location, setLocation] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [subDescription, setSubDescription] = useState<string>("");
  const [price, setPrice] = useState<number>();

  const { sectionId: menuSectionId } = useParams();

  const createMenuItem = async () => {
    if(!props.business || !menuSectionId) {
      return
    }
    setCreating(true);

    const createMenuItem = httpsCallable(functions, 'createMenuItem');
    await createMenuItem({
      business: props.business.id,
      location: location,
      section: menuSectionId,
      description: description,
      subDescription: subDescription,
      price: price,
    }).then(() => {
      navigate("/menu");
    });
  };

  return (
      <div>
        <Form className={"mb-3"}>
          <LocationSelector business={props.business} setValue={setLocation}/>
          <TextField label={"Description"} subLabel={"For example: Mahou"} value={description} setValue={setDescription} required={true}/>
          <TextField label={"Additional Info"} subLabel={"For example: 330ml bottle"} value={subDescription} setValue={setSubDescription} required={false}/>
          <NumberField label={"Price"} subLabel={"For example: 4.50"} unit={<>€</>} step={0.01} placeholder={""} required={true} value={price} setValue={setPrice} />
        </Form>
        {!creating && <div className={"primary-button"} onClick={() => createMenuItem()}>Create Menu Item</div>}
        {creating && <div className={"primary-button"}>Creating...</div>}
      </div>
  );
}

export default MenuItemCreationPage;